'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = require('react-redux');

var _actions = require('../actions');

var _Link = require('../components/UI/Link.jsx');

var _Link2 = _interopRequireDefault(_Link);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    selected: state.currentTask.content == ownProps.file
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    onClick: function onClick() {
      dispatch((0, _actions.setContent)(ownProps.file));
    }
  };
};

var TaskContentLink = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_Link2.default);

exports.default = TaskContentLink;


//////////////////
// WEBPACK FOOTER
// ./client/containers/taskContentLink.js
// module id = 81
// module chunks = 0